/* Replay on every full re-entry; reveal the guidance only after the phone is upright. */
(function () {
  'use strict';
  if (window.mnlDirectionLoaded) return;
  window.mnlDirectionLoaded = true;
  function init(root) {
    root.querySelectorAll('[data-mnl-direction]').forEach(function (scene) {
      if (scene.__direction) return;
      scene.__direction = true;
      var video = scene.querySelector('video');
      var panel = scene.querySelector('.mnl-ins-compound__decision');
      var canvas = scene.querySelector('.mnl-ins-compound__canvas');
      var context = canvas && canvas.getContext('2d');
      var visible = false;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var contours = window.mnlDirectionContours || [];
      var frameCallback = null;
      var disposed = false;
      // Union of all source silhouettes plus a 2px margin: x870, y374, 1076x1350.
      var paths = contours.map(function (contour) {
        if (contour === 'none') return null;
        // Discard the exterior rectangle; clip the decoded frame to the phone itself.
        var pairs = contour.match(/[-\d.]+% [-\d.]+%/g).slice(5);
        var path = new Path2D();
        pairs.forEach(function (pair, i) {
          var xy = pair.split(' ').map(parseFloat);
          var x = xy[0] * 2880 / 100 - 870;
          var y = xy[1] * 1724 / 100 - 374;
          if (i) path.lineTo(x, y);
          else path.moveTo(x, y);
        });
        path.closePath();
        return path;
      });
      function stopTracking() {
        if (frameCallback === null) return;
        if (video.cancelVideoFrameCallback) video.cancelVideoFrameCallback(frameCallback);
        else cancelAnimationFrame(frameCallback);
        frameCallback = null;
      }
      function showPoster() {
        scene.classList.remove('is-direction-video-visible');
      }
      function drawFrame(time, exactFrame) {
        if (!context || video.readyState < 2) return;
        var frame = exactFrame ? Math.round(time * 30) : Math.floor(time * 30 + 0.0001);
        var index = Math.min(paths.length - 1, Math.max(0, frame));
        context.clearRect(0, 0, canvas.width, canvas.height);
        if (paths[index]) {
          context.save();
          context.clip(paths[index]);
          // Video pixels and their outline are committed as one bitmap, not separate layers.
          context.drawImage(video, 870, 374, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
          context.restore();
        }
        scene.classList.add('is-direction-video-visible');
      }
      function trackFrame(now, metadata) {
        frameCallback = null;
        if (disposed || !visible || document.hidden || blocked || reduced || video.paused) return;
        drawFrame(metadata ? metadata.mediaTime : video.currentTime, !!metadata);
        startTracking();
      }
      function syncContour() {
        if (scene.classList.contains('is-direction-video-visible')) drawFrame(video.currentTime);
      }
      function startTracking() {
        if (frameCallback !== null || disposed || !visible || document.hidden || reduced || video.paused) return;
        frameCallback = video.requestVideoFrameCallback
          ? video.requestVideoFrameCallback(trackFrame) : requestAnimationFrame(trackFrame);
      }
      showPoster();
      video.addEventListener('play', startTracking);
      if (location.hostname === '127.0.0.1' && new URLSearchParams(location.search).has('direction_perf')) {
        video.addEventListener('playing', function () {
          var start = performance.now(), last = start, times = [];
          requestAnimationFrame(function measure(now) {
            if (disposed || video.paused) return;
            times.push(now - last); last = now;
            if (now - start < 3000) requestAnimationFrame(measure);
            else {
              times.sort(function (a, b) { return a - b; });
              console.debug('Direction video frames', JSON.stringify({ count: times.length,
                p95: times[Math.floor(times.length * .95)], over32: times.filter(function (n) { return n > 32; }).length }));
            }
          });
        });
      }
      video.addEventListener('seeked', syncContour);
      video.addEventListener('error', showPoster);
      video.addEventListener('pause', stopTracking);
      video.addEventListener('ended', syncContour);
      function reveal() {
        if (!visible || video.currentTime < 2.85) return;
        scene.classList.add('is-direction-ready');
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');
      }
      var blocked = false;
      video.muted = true;
      video.playsInline = true;
      video.defaultMuted = true;
      function retryOnGesture() {
        if (blocked && visible && !disposed) play();
      }
      document.addEventListener('touchend', retryOnGesture, true);
      document.addEventListener('click', retryOnGesture, true);
      function play() {
        scene.classList.toggle('is-direction-paused', !visible || document.hidden);
        if (!visible || document.hidden || video.ended) { video.pause(); return; }
        if (reduced) {
          video.pause();
          showPoster();
          scene.classList.add('is-direction-ready');
          panel.removeAttribute('inert');
          panel.setAttribute('aria-hidden', 'false');
          return;
        }
        blocked = false;
        video.play().then(function () { blocked = false; startTracking(); }).catch(function (error) {
          blocked = error.name === 'NotAllowedError';
          showPoster();
        });
      }
      video.addEventListener('timeupdate', reveal);
      video.addEventListener('seeked', reveal);
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
        if (!entry.isIntersecting) {
          video.pause();
          showPoster();
          if (video.readyState) video.currentTime = 0;
          scene.classList.remove('is-direction-ready');
          panel.setAttribute('inert', '');
          panel.setAttribute('aria-hidden', 'true');
        }
        play();
      }, { threshold: [0, 0.35] });
      observer.observe(scene);
      // Fetch before entry so normal autoplay does not wait for the first range request.
      var preloadObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || reduced) return;
        video.preload = 'auto';
        preloadObserver.disconnect();
      }, { rootMargin: '600px' });
      preloadObserver.observe(scene);
      document.addEventListener('visibilitychange', play);
      (scene.closest('.shopify-section') || scene).addEventListener('shopify:section:unload', function () {
        disposed = true;
        document.removeEventListener('touchend', retryOnGesture, true);
        document.removeEventListener('click', retryOnGesture, true);
        stopTracking();
        preloadObserver.disconnect();
        video.removeEventListener('play', startTracking);
        video.removeEventListener('seeked', syncContour);
        video.removeEventListener('error', showPoster);
        video.removeEventListener('pause', stopTracking);
        video.removeEventListener('ended', syncContour);
        observer.disconnect();
        video.pause();
        document.removeEventListener('visibilitychange', play);
        video.removeEventListener('timeupdate', reveal);
        video.removeEventListener('seeked', reveal);
        delete scene.__direction;
      }, { once: true });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
